import {
  isTextClubMessage,
  type ChildBridge,
  type HostMessage,
  type SdkMessage,
} from "@textclub/common/bridge";
import { createConversationId } from "@textclub/common/random-id";

export class IFrameChildBridge implements ChildBridge {
  public onMessage: (message: SdkMessage) => void = () => {};
  private boundOnMessage: (event: MessageEvent) => void;

  constructor(
    private sdkContextId: string,
    private sdkVersion: string,
  ) {
    this.boundOnMessage = (e: MessageEvent) => {
      const messageData = e.data as unknown;

      if (!isTextClubMessage(messageData)) {
        return;
      }

      // TEMPORARILY disable this check as it's broken.
      // if (messageData.sdkContextId !== this.sdkContextId) {
      //   // If this happens on the client, we can't really log analytics, as the
      //   // bridge is not functional.
      //   // In this case just log to the console and ignore.
      //   console.error("SDK context mismatch", {
      //     expectedSdkContextId: this.sdkContextId,
      //     actualSdkContextId: messageData.sdkContextId,
      //     messageType: messageData.type,
      //   });
      //   return;
      // }

      try {
        this.onMessage(messageData as SdkMessage);
      } catch (_error: unknown) {
        console.error("Invalid message received", e.data);
      }
    };

    window.addEventListener("message", this.boundOnMessage);
  }

  sendMessage(message: HostMessage) {
    window.parent.postMessage(
      {
        source_channel: "textclub",
        ...message,
        conversationId: message.conversationId ?? createConversationId(),
        sdkContextId: this.sdkContextId,
        sdkVersion: this.sdkVersion,
      },
      "*",
    );
  }
}
